import React from "react";
import "../style/applayout.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
const AppLayout = (props) => {
  return (
    <div>
      <Header/>
      <div className="applayount d-flex flex-row gap-3">
        <div className="sidebar d-none d-sm-block">
          <Sidebar />
        </div>
        <div className="content">{props.children}</div>
      </div>
    </div>
  );
};

export default AppLayout;
